module.exports = __webpack_public_path__ + "img/radio-bintulu.e168e057.jpg";